import React, { useState, useContext } from "react";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "./CustomInput";
import "./OtpStyles.css";
import { BsPlayCircle } from "react-icons/bs";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { onecodeAPI } from "../AppConfig";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import WatchVideo from "./WatchVideo";
import VideoContainer from "./VideoContainer";
import { useTranslation } from 'react-i18next';
import { Context } from "../App";
import { isCharWithoutSymbol } from "../utils/regexConstants";

export default function FirstForm({
  setCurrentScreen,
  customer,
  setCustomerName,
  setCustomerPhoneNum,
  currentScreen,
  isCreditScoreCheck,
  setCusStatusforCreditScore,
  setCusHashforCreditScore,
  setCustomerId
}) {
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  
  const phoneRegExp = /^[1-9]{1}[0-9]{9}$/;
  const { t } = useTranslation();
  const[lockedTill,setLockedTill]=useState({});
  const { isMyTeamsFlow } = useContext(Context);



  const navigate = useNavigate();

  
  // Adding Customer
  const addCustomer = async (name, phoneNumber) => {
    window?.Moengage?.track_event("add-customer_customer_continue_1", {
      customer_name: name,
      customer_phone: phoneNumber,
    });
    if(isCreditScoreCheck){
      window?.Moengage?.track_event("credit-score_continue", {
        customer_name: name,
        customer_phone: phoneNumber,
      });
    }
    try {
      setLoading(true);
      let hash = encodeURIComponent(searchParams.get("hash"));
      const res = await onecodeAPI.post(`public/customer/addCustomerOtp?isCreditCheck=${isCreditScoreCheck}`, {
        fullName: name,
        phoneNumber: phoneNumber,
        hash: hash,
      });
      // console.log(res,"ssendOtp");
      setCustomerName(name);
      setCustomerPhoneNum(phoneNumber);
      setSearchParams({ hash: decodeURIComponent(res.data.hash) });
      setCustomerId(res.data.customerId);

      const object={      
       lock: res.data.lockedTill,
       reaso:res.data.reason,
      }
      setLockedTill(object)
      
      if(res.data.lockedTill==null){
        if(isCreditScoreCheck){
        setCurrentScreen(1);
        let status = res?.data?.customerStatus;
        let hash = decodeURIComponent(res?.data?.hash);
        setCusStatusforCreditScore(status);
        setCusHashforCreditScore(hash);
      }
      else if (res.data.customerStatus === 2 || res?.data?.customerStatus == null)
        setCurrentScreen(1);
        else if (res.data.customerStatus === 3 || res.data.customerStatus === 6)
        setCurrentScreen(2);
        else {
        navigate(`/customer/recommendations`, {
          state: { hash: decodeURIComponent(res.data.hash) },
        });
      }
    
      
    }
    setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "white" }} spin />
  );

  const customerSchema = Yup.object({
    name: Yup.string().matches(isCharWithoutSymbol, "Special characters not allowed").required("Required"),
    phonenumber: Yup.string()
      .matches(phoneRegExp, "Invalid phone number")
      .required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      name: customer?.fullName || "",
      phonenumber: customer?.phoneNumber || "",
    },
    validationSchema: customerSchema,
    onSubmit: (values) => {
      addCustomer(values.name, values.phonenumber);
      // setCurrentScreen(1);
    },
  });

  return (
    <div
      style={{
        // border: "1px solid red",
        marginTop: isCreditScoreCheck ? "50px" : "",
        paddingTop: isCreditScoreCheck ? "15px" : "",
        width: isCreditScoreCheck ? "90%" : "",
        margin: isCreditScoreCheck ? "0 auto" : "",
        paddingBottom: isCreditScoreCheck ? "20px" : "",
        borderRadius: isCreditScoreCheck ? "10px":"",
        backgroundColor: isCreditScoreCheck ? "#F5F5F5":"",
        boxShadow: isCreditScoreCheck ?"0px 0px 60px rgba(174, 174, 174, 0.25);":""
      }}
    >
      <form
        onSubmit={formik.handleSubmit}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
          marginTop: isCreditScoreCheck ? "" : "38px",
        }}
      >
        <CustomInput
          label={t("addcustomerstep1.customer'sname")}
          handleChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          value={formik.values.name}
          name="name"
        />
        {formik.touched.name && formik.errors.name ? (
          <div className="error">{formik.errors.name}</div>
        ) : null}
        <CustomInput
          label={t("addcustomerstep1.customer'smobilenumber")}
          text="number"
          handleChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          value={formik.values.phonenumber}
          name="phonenumber"
        />
        {formik.touched.phonenumber && formik.errors.phonenumber ? (
          <div className="error">{formik.errors.phonenumber}</div>
        ) : null}
     
  
      <button
          type="submit"
          style={{
            background:"#6C63FF",
            border: "none",
            color: "white",
            padding: 12.5,
            borderRadius: 5,
            margin: "auto",
            width: "90%",
            marginTop: "22.5px",
            
        }}
        >
          {loading && <Spin indicator={antIcon} />}
          {t("addcustomerstep1.continue")}
        </button>
      <div>
      
      <p style={{color:"red",marginLeft:"130px",marginTop:"20px"}}>{lockedTill.reaso}</p> 
            {/* <p style={{alignSelf: "center",textAlign: "center",color:"red",marginLeft:"80px",marginTop:"-10px"}}>{lockedTill.lock}</p> */}
      </div>

        {/* <VideoContainer/> */}

        {!isCreditScoreCheck ? (
          <div className="WatchVideo">
            <WatchVideo
              videoTitle={t("addcustomerstep1.HowtoApply")}
              videoId={t("addcustomerstep1.videoId")}
              eventName={"add-customer_customer_watch_video"}
              currentScreen={currentScreen}
              thumbnail={
                "https://onecode-asset.s3.ap-south-1.amazonaws.com/Add_customer_Thumbnail_customer.jpg"
              }
            />
          </div>
        ) : (
          <></>
        )}
      </form>
    </div>
  );
}
